import React from 'react';
import { useNavigate } from 'react-router-dom';

const Legal = () => {
  const navigate = useNavigate();

  return (
    <div style={styles.container}>
      <nav style={styles.nav}>
        <div style={styles.logo}>M / B LEGAL</div>
        <button onClick={() => navigate('/signup')} style={styles.backBtn}>CLOSE & RETURN</button>
      </nav>

      <div style={styles.content}>
        <h1 style={styles.title}>LEGAL PROTOCOLS</h1>

        <section style={styles.section}>
          <h3 style={{color: 'var(--gold)'}}>DATA SYNC & ANONYMIZATION (Optional Opt-In)</h3>
          <p>
            If you choose to opt-in to Data Sync, we collect usage patterns (which buttons you click, how long you spend on strategy modules) to improve the MOB interface.
          </p>
          <p><strong>Security Architecture:</strong> We assign a unique ID number to your account. Your usage data is tied to this number, not your legal name or identity. We will NEVER ask for, store, or have access to your banking information or external passwords.</p>
        </section>

        <section style={styles.section}>
          <h3>1. NO PROFESSIONAL ADVICE</h3>
          <p>MOB is a strategy tool, not a psychiatric or medical service. Use at your own risk.</p>
        </section>

        <section style={styles.section}>
          <h3>2. NO INCOME GUARANTEE</h3>
          <p>We provide the dashboard; you provide the execution. Results are not guaranteed.</p>
        </section>

        <section style={styles.section}>
          <h3>3. PRIVACY COMMITMENT</h3>
          <p>We do not sell data. We are built on Firebase security standards to protect your "War Room" intellectual property.</p>
        </section>
      </div>
    </div>
  );
};

const styles = {
  container: { background: 'var(--bg-deep)', minHeight: '100vh', color: '#ccc', fontFamily: 'Inter, sans-serif' },
  nav: { padding: '20px', borderBottom: '1px solid #333', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#000' },
  logo: { color: 'var(--gold)', fontFamily: 'Orbitron', fontSize: '1.2rem' },
  backBtn: { background: 'transparent', border: '1px solid #444', color: '#fff', padding: '10px 20px', cursor: 'pointer' },
  content: { maxWidth: '800px', margin: '0 auto', padding: '40px 20px' },
  title: { color: '#fff', marginBottom: '20px', fontFamily: 'Orbitron' },
  section: { marginBottom: '40px', paddingBottom: '20px', borderBottom: '1px solid #222' }
};

export default Legal;
